import React, { useState, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { authenticationService } from '../../services/AuthService';
import { localStorageService } from '../../services/localstorage-service';

import '../login-form/LoginForm.scss';

export default function ForgotPasswordForm() {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const formData = useRef({ email: localStorageService.getEmail() || '' });

  const toast = (message, type = 'error') => {
    notify({
      message: message,
      position: { my: 'top center', at: 'top center', of: window, offset: '0 70' }
    }, type, 5000);
  };

  const emailValidation = (email) => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return !(!email || regex.test(email) === false);
  };

  const normalizeLoginEmail = (raw) => {
    if (!raw) {
      return '';
    }
    const trimmed = raw.trim().replace(/\s+/g, '');
    const colonIndex = trimmed.indexOf(':');
    if (colonIndex < 0) {
      return trimmed;
    }
    const chain = trimmed.slice(0, colonIndex).trim();
    const localPart = trimmed.slice(colonIndex + 1).trim().toLowerCase();
    return `${chain}:${localPart}`;
  };

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const email = normalizeLoginEmail(formData.current.email);
    formData.current.email = email;
    const colonIndex = email.indexOf(':');
    if (colonIndex < 0) {
      toast('Kolon mangler');
      return;
    }
    if (colonIndex === 0) {
      toast('Kjedenavn er påkrevet');
      return;
    }
    if (!emailValidation(email.slice(colonIndex + 1))) {
      toast('Vennligst tast inn en gyldig epost-adresse');
      return;
    }

    setLoading(true);
    try {
      const response = await authenticationService.forgotPassword(email);
      setSubmitted(true);
      toast(response.message || 'Hvis kontoen finnes, er det sendt e-post med instruksjoner.', 'success');
    } catch {
      toast('Noe gikk galt. Vær så snill, prøv på nytt.');
    } finally {
      setLoading(false);
    }
  }, []);

  if (submitted) {
    return (
      <div className="login-form">
        <p className="form-text">
          Hvis kontoen finnes, er det sendt e-post med instruksjoner for tilbakestilling av passord.
        </p>
        <div className="link">
          <Link to="/login">Tilbake til innlogging</Link>
        </div>
      </div>
    );
  }

  return (
    <form className="login-form" onSubmit={onSubmit}>
      <p className="form-text">
        Skriv inn kjedenavn og e-postadresse (samme format som ved innlogging, f.eks. Kjede:epost@eksempel.no).
      </p>
      <Form formData={formData.current} disabled={loading}>
        <Item
          dataField="email"
          editorType="dxTextBox"
          editorOptions={emailEditorOptions}
        >
          <RequiredRule message="E-post er påkrevd" />
          <Label visible={false} />
        </Item>
        <ButtonItem>
          <ButtonOptions width="100%" type="default" useSubmitBehavior={true}>
            <span className="dx-button-text">
              {loading
                ? <LoadIndicator height={24} width={24} indicatorSrc="loading-buffering.gif" />
                : 'Send tilbakestillingslenke'}
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      <div className="link">
        <Link to="/login">Tilbake til innlogging</Link>
      </div>
    </form>
  );
}

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Kjede:epost@eksempel.no', mode: 'text' };
